module.exports = __webpack_public_path__ + "media/images/channels/traumatology-dd2417fd4a669a2d9a03c3dfc0330a24.jpg";